import * as React from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";

export const DEFAULT_TIME = "12:00";

export function parseValue(value, showTime) {
  if (!value) return null;
  let date;
  if (value.includes("T")) {
    date = new Date(value);
  } else {
    const [year, month, day] = value.split("-").map(Number);
    date = new Date(year, month - 1, day, 12, 0, 0);
  }
  if (isNaN(date.getTime())) return null;
  if (showTime) {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return { date, time: `${hours}:${minutes}` };
  }
  return { date, time: DEFAULT_TIME };
}

export function formatDisplay(value, showTime) {
  const parsed = parseValue(value, showTime);
  if (!parsed) return null;
  // App is forced Spanish — format dates in es so the picker matches the rest
  // of the UI (was date-fns default en-US: "Jun 5, 2026").
  return showTime
    ? format(parsed.date, "d MMM yyyy 'a las' HH:mm", { locale: es })
    : format(parsed.date, "d MMM yyyy", { locale: es });
}

export function useDateTimeValue(value, showTime) {
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedTime, setSelectedTime] = React.useState(DEFAULT_TIME);
  const [calMonth, setCalMonth] = React.useState(() => new Date());

  const hydrateFromValue = React.useCallback(() => {
    const parsed = parseValue(value, showTime);
    if (parsed) {
      setSelectedDate(parsed.date);
      setCalMonth(parsed.date);
      if (showTime) setSelectedTime(parsed.time);
    } else {
      setSelectedDate(null);
      setSelectedTime(DEFAULT_TIME);
    }
  }, [value, showTime]);

  React.useEffect(() => {
    hydrateFromValue();
  }, [hydrateFromValue]);

  const displayValue = React.useMemo(() => formatDisplay(value, showTime), [value, showTime]);

  return {
    selectedDate,
    setSelectedDate,
    selectedTime,
    setSelectedTime,
    calMonth,
    setCalMonth,
    displayValue,
    hydrateFromValue,
  };
}
